const USER_GROUPS = {
  DHL: 'DHL',
  CPFL: 'CPFL',
  CPFL_DEPOSITO: 'CPFL_DEPOSITO',
  CPFL_GERENCIAL: 'CPFL_GERENCIAL',
  RGE: 'RGE',
  RGE_DEPOSITO: 'RGE_DEPOSITO', 
}

export const GROUP_MAP_PERMISSION = [
  USER_GROUPS.DHL,
  USER_GROUPS.CPFL_GERENCIAL
]

export const ALL_WAREHOUSE_PERMISSION = [
  USER_GROUPS.DHL,
  USER_GROUPS.CPFL_GERENCIAL
]

export const WAREHOUSE_GROUPS = [
  USER_GROUPS.RGE,
  USER_GROUPS.CPFL_DEPOSITO,
  USER_GROUPS.RGE_DEPOSITO,
  USER_GROUPS.CPFL_GERENCIAL
]

export const ALL_GROUPS = Object.keys(USER_GROUPS).map(key => USER_GROUPS[key])

export default USER_GROUPS